module.exports = __webpack_public_path__ + "static/img/蒙版组 35.ba76796.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/蒙版组 35.png
// module id = 4apr
// module chunks = 0